import { Box, Grid, Typography, Stack } from '@mui/material';
import React from 'react';

import { EnlargedImage } from '@app/components/Shared/EnlargedImage';
import { theme } from '@app/theme';
import {
  ProductVariant,
  ProductVariantAroundCategory,
  ProductVariantEquipmentCategory,
  ProductVariantExteriorCategory,
  ProductVariantInteriorCategory,
  ProductVariantSku,
} from '@app/types/catalog';

interface PropertyVariantSkuDetailsProps {
  variants: ProductVariant[];
}

const renderVariantSection = (
  title: string,
  variants: ProductVariant[],
  category: {
    [key: string]: {
      key: string;
      label: string;
    };
  },
  bgColor: string
): React.ReactNode => {
  if (variants.length === 0) {
    return null;
  }

  return (
    <Box width="100%" bgcolor={bgColor} px={2} py={{ sm: 9, xs: 4 }}>
      <Stack width="100%" maxWidth={1040} mx="auto" gap={2}>
        <Typography
          width="100%"
          bgcolor={theme.palette.blueAccent.main}
          color="white"
          mb={2}
          px={2}
          height={36}
          fontWeight={600}
          borderRadius={15}
          display="flex"
          alignItems="center"
          variant="h6"
        >
          {title}
        </Typography>
        <Grid container columnSpacing={4} rowSpacing={4} minHeight={500}>
          {variants.map((variant, idx) => (
            <Grid item xs={12} sm={6} key={idx}>
              <Stack
                width="100%"
                bgcolor="white"
                border="1px solid #E0E0E0"
                borderRadius={3}
                px={{ sm: 4, xs: 2 }}
                py={{ sm: 4, xs: 2 }}
              >
                {variant.images?.[0]?.url && (
                  <Box width="100%">
                    <EnlargedImage
                      src={variant.images[0].url}
                      title={
                        variant.sku === ProductVariantSku.EQUIPMENT
                          ? variant.title
                          : Object.values(category).find(
                              (category) =>
                                category.key === variant.customFields?.category
                            )?.label || ''
                      }
                      mt={3}
                      objectFit="contain"
                    />
                  </Box>
                )}

                <Typography fontWeight={600} mt={3}>
                  {variant.sku === ProductVariantSku.EQUIPMENT
                    ? variant.title
                    : Object.values(category).find(
                        (category) =>
                          category.key === variant.customFields?.category
                      )?.label}
                </Typography>

                <Typography mt={1}>{variant.description}</Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  );
};

export function PropertyVariantSkuDetails({
  variants,
}: PropertyVariantSkuDetailsProps) {
  const exteriorVariants = variants.filter(
    (variant) => variant.sku === ProductVariantSku.EXTERIOR
  );
  const aroundVariants = variants.filter(
    (variant) => variant.sku === ProductVariantSku.AROUND
  );
  const equipmentVariants = variants.filter(
    (variant) => variant.sku === ProductVariantSku.EQUIPMENT
  );
  const interiorVariants = variants.filter(
    (variant) => variant.sku === ProductVariantSku.INTERIOR
  );

  return (
    <>
      {renderVariantSection(
        '外観',
        exteriorVariants,
        ProductVariantExteriorCategory,
        '#f5f8fc'
      )}
      {renderVariantSection(
        '内観',
        interiorVariants,
        ProductVariantInteriorCategory,
        'white'
      )}
      {renderVariantSection(
        '設備',
        equipmentVariants,
        ProductVariantEquipmentCategory,
        '#f5f8fc'
      )}
      {renderVariantSection(
        '周辺環境',
        aroundVariants,
        ProductVariantAroundCategory,
        'white'
      )}
    </>
  );
}
